export default "__VITE_ASSET__Bu49SFny__"